import Format from 'atpjs/components/form/format'

const normalizeIban = (input) => {
  input = input || ''
  return String(input).replace(/[^A-Za-z0-9]/g, '')
}

const formatIban = (input) => {
  input = normalizeIban(input)
  let country = ''
  let numbers = ''
  const indexOfFirstNumber = input.search(/\d/)
  if (indexOfFirstNumber >= 0) {
    numbers = input.substr(indexOfFirstNumber).toUpperCase()
    if (indexOfFirstNumber < 2) {
      country = 'CH'
    } else {
      country = input
        .substr(0, indexOfFirstNumber)
        .substr(-2)
        .toUpperCase()
    }
  } else {
    return String(input)
  }
  return (country + numbers).match(/.{0,4}/g).join('')
}

class IbanInput extends Format {
  static defaultProps = {
    ...Format.defaultProps,
    options: {
      blocks: [4, 4, 4, 4, 4, 1],
      uppercase: true
    }
  }

  normalizeValue(value) {
    return formatIban(value)
  }
}

export default IbanInput
export { normalizeIban, formatIban }
